import React from 'react';
import { connect } from 'react-redux';

import Loader from 'components/layout/Loader';
import ScrollTrigger from 'react-scroll-trigger';
import Plx from 'react-plx';

import { getLocationsPath } from 'helpers/intl';

import AbstractCmsElement from 'components/cms/elements/AbstractCmsElement';

import LocationsMap from 'components/layout/maps/LocationsMap';

import List from 'components/List';

import { GOOGLE_MAPS_URL } from 'js/constants';

class CmsElementLocations extends AbstractCmsElement {
  constructor(props) {
    super(props);

    this.allowStateChange = true;

    this.state = {
      shown: false,
      defaultsInit: false,
      zoom: 13,
      center: {
        lat: 49.2401572,
        lng: 6.9969327,
      },
    };
  }

  componentDidUpdate = (prevProps, prevState) => {
    const { locations } = this.props;

    if (!locations.pending && !locations.hasError && prevProps.locations.pending) {
      this.calculateMapCenter(locations.data.list);
    }

    this.__componentDidUpdate(prevProps, prevState);
  };

  shown = () => {
    if (this.allowStateChange) {
      this.setState({ shown: true });
    }
  };

  calculateZoomLevel = (west, east) => {
    // https://stackoverflow.com/questions/6048975/google-maps-v3-how-to-calculate-the-zoom-level-for-a-given-bounds
    const GLOBE_WIDTH = 256; // a constant in Google's map projection
    let angle = east - west;
    if (angle < 0) {
      angle += 360;
    }
    let zoom = Math.round(Math.log((window.innerWidth * 360) / angle / GLOBE_WIDTH) / Math.LN2) - 1;
    zoom = Math.min(zoom, 17);

    return zoom;
  };

  calculateMapCenter = list => {
    if (!list || !list.length) {
      return;
    }

    let maxLat = list[0].coordinates.lat;
    let minLat = list[0].coordinates.lat;
    let maxLng = list[0].coordinates.lng;
    let minLng = list[0].coordinates.lng;

    // Calculate bounds
    list.forEach(element => {
      if (element.coordinates.lat > maxLat) maxLat = element.coordinates.lat;
      if (element.coordinates.lat < minLat) minLat = element.coordinates.lat;

      if (element.coordinates.lng > maxLng) maxLng = element.coordinates.lng;
      if (element.coordinates.lng < minLng) minLng = element.coordinates.lng;
    });

    // Calculate center between bounds
    const centerLat = (maxLat + minLat) / 2.0;
    const centerLng = (maxLng + minLng) / 2.0;

    const zoom = this.calculateZoomLevel(minLng, maxLng);

    this.setState({ center: { lat: centerLat, lng: centerLng }, zoom, defaultsInit: true });
  };

  getLink = location => {
    return getLocationsPath() + '/' + location.id + '-' + location.name;
  };

  render() {
    const { locations } = this.props;
    const { shown, defaultsInit, zoom, center } = this.state;

    /* Before the update there was a scriptloader for GoogleMaps here.
    This was removed for compatibility reasons... no alternative yet */

    const shownClass = shown ? 'elem-shown ' : 'elem-hidden ';

    const urlData = { distance: 100 };

    const parallaxData = this.getParallaxData();

    const innerContent = (
      <div
        id={this.getMainId()}
        className={'ms-map ' + shownClass + this.getResponsiveClasses() + this.getCssClasses()}
        style={{ ...this.getBackgroundStyle(), height: this.getParamValue('mapHeight', 300) + 'px' }}
      >
        {this.getElementStyle()}

        <List
          noRender
          listName="companyLocations"
          url="/api/whitelabellocations.json"
          urlData={urlData}
          list={locations}
        />

        {!locations.pending && defaultsInit ? (
          <LocationsMap locations={locations} zoom={zoom} center={center} getLink={this.getLink} />
        ) : null}

        {this.getAppendHtml()}
      </div>
    );

    return (
      <ScrollTrigger onEnter={this.shown} {...this.getCustomId()}>
        {parallaxData ? <Plx parallaxData={parallaxData}>{innerContent}</Plx> : innerContent}
      </ScrollTrigger>
    );
  }
}
CmsElementLocations.defaultProps = {
  index: '0',
};

const mapStateToProps = state => {
  return {
    locations: state.list.companyLocations,
  };
};

export default connect(mapStateToProps)(CmsElementLocations);
